import React from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useBarnsWithHorses } from "components/Location/useBarnsWithHorses";
import { mapPropsAreEqual } from "components/MapComponents/mapPropsAreEqual";

import useStyles from "./styles";

interface Props {
  containerSize: {
    width: number;
    height: number;
  };
  horses: racehorse360.IHorse[];
  mapRootRef: React.RefObject<SVGGElement>;
  clipPathRef: React.RefObject<SVGRectElement>;
  svgContainerRef: React.RefObject<HTMLDivElement>;
  handleGroupClick?: (e: React.MouseEvent) => void;
  isPreview?: boolean;
}

const DelMarMap = (props: Props) => {
  const {
    mapRootRef,
    containerSize,
    svgContainerRef,
    clipPathRef,
    handleGroupClick,
    horses,
    isPreview
  } = props;

  const stylesProps = { isPreview };
  const classes = useStyles(stylesProps);

  const barnsWithHorses = useBarnsWithHorses(horses);

  return (
    <div ref={svgContainerRef}>
      <svg
        width={containerSize.width}
        height={containerSize.height}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 950.4 658"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              ref={clipPathRef}
              className={classes.cls1}
              width="950.4"
              height="658"
            />
          </clipPath>
        </defs>
        <g ref={mapRootRef}>
          <rect className={classes.st27} y=".8" width="950" height="653" />
          <g>
            <path
              className={classes.st31}
              d="M.4.8h210l-60,120-90,90L.4,260.8V.8Z"
            />
            <path
              className={classes.st31}
              d="M.4,470.8l70-40,70,90-20,133H.4v-183Z"
            />
            <path
              className={classes.st31}
              d="M700.4.8h140l10,90-90-20L700.4.8Z"
            />
            <path
              className={classes.st31}
              d="M866.4,250.8h84v403h-70l-18-183,4-220Z"
            />
          </g>
          <g>
            <path
              className={classes.st21}
              d="M.4,48.8l300-3,340,50,60,13,145,2"
            />
            <path
              className={classes.st21}
              d="M694.4,115.8l-16,175-16,130-42,100-100,65-190,68"
            />
            <path className={classes.st21} d="M300.4,45.8L292.4.8" />
            <path className={classes.st21} d="M612.4,44.8l6-36" />
            <path className={classes.st21} d="M420.4,470.8l50,50,90,40" />
          </g>
          <g>
            <path
              className={classes.st22}
              d="M.4,48.8l300-3,340,50,60,13,145,2"
            />
            <path
              className={classes.st22}
              d="M694.4,115.8l-16,175-16,130-42,100-100,65-190,68"
            />
            <path className={classes.st22} d="M300.4,45.8L292.4.8" />
            <path className={classes.st22} d="M612.4,44.8l6-36" />
            <path className={classes.st22} d="M420.4,470.8l50,50,90,40" />
          </g>
          <path className={classes.st19} d="M828.4.8l24,653" />
          <path className={classes.st20} d="M828.4.8l24,653" />
          <g>
            <path
              className={classes.st30}
              d="M204.1,204.7l209.6,60.1c52,14.9,82.1,69.2,67.2,121.2h0c-14.9,52-69.2,82.1-121.2,67.2l-209.6-60.1c-52-14.9-82.1-69.2-67.2-121.2h0c14.9-52,69.2-82.1,121.2-67.2Z"
            />
            <path
              className={classes.st32}
              d="M198.1,225.8l209.6,60.1c40.3,11.6,63.7,53.7,52.1,94h0c-11.6,40.3-53.7,63.7-94,52.1l-209.6-60.1c-40.3-11.6-63.7-53.7-52.1-94h0c11.6-40.3,53.7-63.7,94-52.1Z"
            />
            <path
              className={classes.st28}
              d="M196.1,247.1l201.9,57.9c29.2,8.4,46.1,38.8,37.7,68h0c-8.4,29.2-38.8,46.1-68,37.7l-201.9-57.9c-29.2-8.4-46.1-38.8-37.7-68h0c8.4-29.2,38.8-46.1,68-37.7Z"
            />
            <path
              className={classes.st36}
              d="M187.6,262.3l19.2,5.5c13.8,4,21.8,18.4,17.8,32.2h0c-4,13.8-18.4,21.8-32.2,17.8l-19.2-5.5c-13.8-4-21.8-18.4-17.8-32.2h0c4-13.8,18.4-21.8,32.2-17.8Z"
            />
            <rect
              className={classes.st36}
              x="269.1"
              y="271.4"
              width="58"
              height="118"
              rx="28"
              ry="28"
              transform="translate(-101.7 525.9) rotate(-74)"
            />
            <rect
              className={classes.st35}
              x="367.5"
              y="353.9"
              width="40"
              height="48"
              rx="6"
              ry="6"
              transform="translate(-82.6 646.2) rotate(-74)"
            />
            <rect
              className={classes.st29}
              x="189.1"
              y="322"
              width="7"
              height="54"
              rx="2"
              ry="2"
              transform="translate(-195.9 437.9) rotate(-74)"
            />
            <rect
              className={classes.st29}
              x="236"
              y="346.1"
              width="7"
              height="34"
              rx="2"
              ry="2"
              transform="translate(-175.5 493.2) rotate(-74)"
            />
          </g>
          <rect
            className={classes.st33}
            x="318.4"
            y="78.8"
            width="84"
            height="12"
            rx="2"
            ry="2"
          />
          <g>
            <path
              className={classes.st33}
              d="M470.7,112.8h26v20h-10v14h-16v-34Z"
            />
            <rect
              className={classes.st33}
              x="470.7"
              y="150.8"
              width="27"
              height="15"
              rx="2"
              ry="2"
            />
          </g>
          <rect
            className={classes.st33}
            x="600.4"
            y="142.8"
            width="64"
            height="14"
            rx="2"
            ry="2"
          />
          <path
            className={classes.st33}
            d="M242.4,468.8h96v18h34v34h-118v-20h-12v-32Z"
          />
          <rect
            className={classes.st24}
            x="703.3"
            y="130.6"
            width="20"
            height="13"
            rx="2"
            ry="2"
          />
          <rect
            className={classes.st24}
            x="570.4"
            y="334.1"
            width="66"
            height="50"
            rx="8"
            ry="8"
          />
          <rect
            className={classes.st24}
            x="618.4"
            y="340.1"
            width="24"
            height="16"
            rx="2"
            ry="2"
          />
          <text
            className={classes.st10}
            transform="translate(470.4 58.8) rotate(9)"
          >
            <tspan x="0" y="0">
              VIA DE LA VALLE
            </tspan>
          </text>
          <text className={classes.st10} transform="translate(742.4 102.8)">
            <tspan x="0" y="0">
              VIA DE LA VALLE
            </tspan>
          </text>
          <text className={classes.st10} transform="translate(592.4 36.8)">
            <tspan x="0" y="0">
              STEVENS AVE.
            </tspan>
          </text>
          <text
            className={classes.st10}
            transform="translate(679.6 317.5) rotate(-84.5)"
          >
            <tspan x="0" y="0">
              JIMMY DURANTE BLVD.
            </tspan>
          </text>
          <text
            className={classes.st10}
            transform="translate(389.4 636.5) rotate(-19.8)"
          >
            <tspan x="0" y="0">
              JIMMY DURANTE BLVD.
            </tspan>
          </text>
          <text
            className={classes.st5}
            transform="translate(842.5 300.6) rotate(-92.3)"
          >
            <tspan x="0" y="0">
              INTERSTATE 5
            </tspan>
          </text>
          <text className={classes.st16} transform="translate(255 73.8)">
            <tspan x="62" y="0">
              EQUINE HOSPITAL
            </tspan>
          </text>
          <text className={classes.st16} transform="translate(448.3 108.8)">
            <tspan x="0" y="0">
              STABLE CAFE
            </tspan>
          </text>
          <text className={classes.st17} transform="translate(448.9 161.8)">
            <tspan x="0" y="0">
              RACING OFFICE
            </tspan>
          </text>
          <text className={classes.st18} transform="translate(592 136.8)">
            <tspan x="0" y="0">
              STABLE OFFICES
            </tspan>
          </text>
          <text className={classes.st16} transform="translate(490.4 491.8)">
            <tspan x="0" y="0">
              RECEIVING BARN
            </tspan>
          </text>
          <text className={classes.st16} transform="translate(547.6 370.1)">
            <tspan x="0" y="0">
              HORSE SHOW ARENA
            </tspan>
          </text>
          <text className={classes.st8} transform="translate(622.2 352.1)">
            <tspan x="0" y="0">
              ITW
            </tspan>
          </text>
          <text className={classes.st11} transform="translate(233.9 497.7)">
            <tspan x="0" y="0">
              CLUBHOUSE / GRANDSTAND
            </tspan>
          </text>
          <circle className={classes.st23} cx="299.4" cy="45.8" r="3.4" />
          <text className={classes.st14} transform="translate(306.4 40.8)">
            <tspan x="0" y="0">
              SOLANA GATE
            </tspan>
          </text>
          <circle className={classes.st23} cx="694.5" cy="116.7" r="5.7" />
          <text className={classes.st14} transform="translate(702.7 125)">
            <tspan x="0" y="0">
              MAIN STABLE GATE
            </tspan>
          </text>
          <text className={classes.st9} transform="translate(702.7 155)">
            <tspan x="0" y="0">
              GUARD SHACK / CHRB LICENSING
            </tspan>
          </text>
          <g>
            <path
              className={classes.st0}
              d="M890.4,26.8l12,34-12-7-12,7,12-34Z"
            />
            <text className={classes.st1} transform="translate(885 78.8)">
              <tspan x="0" y="0">
                N
              </tspan>
            </text>
          </g>
          <g id="x4gvCe.tif">
            <image
              id="Layer_0"
              width="2097"
              height="1710"
              transform="translate(684.7 422.5) scale(0)"
            />
          </g>
          <g onClick={handleGroupClick}>
            <g
              data-name="VV"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["vv"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="185"
                y="70.8"
                width="10"
                height="40"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="190" cy="88.4" r="8" />
              <text className={classes.st7} transform="translate(184.5 91.4)">
                <tspan x="0" y="0">
                  VV
                </tspan>
              </text>
            </g>
            <g
              data-name="UU"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["uu"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="185.1"
                y="113.9"
                width="10"
                height="41.9"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="190.1" cy="130.4" r="8" />
              <text className={classes.st6} transform="translate(184.1 133.4)">
                <tspan x="0" y="0">
                  UU
                </tspan>
              </text>
            </g>
            <g
              data-name="TT"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["tt"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="209.2"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="214.2" cy="130.4" r="8" />
              <text className={classes.st6} transform="translate(209.2 133.4)">
                <tspan x="0" y="0">
                  TT
                </tspan>
              </text>
            </g>
            <g
              data-name="SS"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["ss"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="233.2"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="238.2" cy="130.4" r="8" />
              <text className={classes.st7} transform="translate(232.7 133.4)">
                <tspan x="0" y="0">
                  SS
                </tspan>
              </text>
            </g>
            <g
              data-name="RR"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["rr"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="257.4"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="262.4" cy="130.4" r="8" />
              <text className={classes.st6} transform="translate(256.5 133.4)">
                <tspan x="0" y="0">
                  RR
                </tspan>
              </text>
            </g>
            <g
              data-name="QQ"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["qq"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="281.4"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="286.4" cy="130.4" r="8" />
              <text className={classes.st7} transform="translate(280 133.4)">
                <tspan x="0" y="0">
                  QQ
                </tspan>
              </text>
            </g>
            <g
              data-name="PP"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["pp"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="305.5"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="310.5" cy="130.4" r="8" />
              <text className={classes.st7} transform="translate(305 133.4)">
                <tspan x="0" y="0">
                  PP
                </tspan>
              </text>
            </g>
            <g
              data-name="OO"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["oo"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="329.6"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="334.6" cy="130.4" r="8" />
              <text className={classes.st7} transform="translate(328.1 133.4)">
                <tspan x="0" y="0">
                  OO
                </tspan>
              </text>
            </g>
            <g
              data-name="NN"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["nn"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="353.6"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="358.6" cy="130.4" r="8" />
              <text className={classes.st6} transform="translate(352.7 133.4)">
                <tspan x="0" y="0">
                  NN
                </tspan>
              </text>
            </g>
            <g
              data-name="MM"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["mm"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="377.7"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="382.7" cy="130.4" r="8" />
              <text className={classes.st7} transform="translate(375.8 133.4)">
                <tspan x="0" y="0">
                  MM
                </tspan>
              </text>
            </g>
            <g
              data-name="LL"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["ll"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="401.8"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="406.8" cy="130.4" r="8" />
              <text className={classes.st6} transform="translate(401.8 133.4)">
                <tspan x="0" y="0">
                  LL
                </tspan>
              </text>
            </g>
            <g
              data-name="KK"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["kk"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="425.9"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="430.9" cy="130.4" r="8" />
              <text className={classes.st6} transform="translate(424.9 133.4)">
                <tspan x="0" y="0">
                  KK
                </tspan>
              </text>
            </g>
            <g
              data-name="GG"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["gg"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="527.3"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="532.3" cy="130.4" r="8" />
              <text className={classes.st7} transform="translate(525.9 133.4)">
                <tspan x="0" y="0">
                  GG
                </tspan>
              </text>
            </g>
            <g
              data-name="FF"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["ff"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="551.4"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="556.4" cy="130.4" r="8" />
              <text className={classes.st6} transform="translate(551.4 133.4)">
                <tspan x="0" y="0">
                  FF
                </tspan>
              </text>
            </g>
            <g
              data-name="EE"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["ee"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="575.4"
                y="100.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="580.4" cy="130.4" r="8" />
              <text className={classes.st7} transform="translate(575 133.4)">
                <tspan x="0" y="0">
                  EE
                </tspan>
              </text>
            </g>
            <g
              data-name="U"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["u"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="184.8"
                y="165.3"
                width="10"
                height="20"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="189.8" cy="182.5" r="8" />
              <text className={classes.st6} transform="translate(186.8 185.5)">
                <tspan x="0" y="0">
                  U
                </tspan>
              </text>
            </g>
            <g
              data-name="T"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["t"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="208.9"
                y="165"
                width="10"
                height="23"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="213.9" cy="182.1" r="8" />
              <text className={classes.st6} transform="translate(211.4 185.1)">
                <tspan x="0" y="0">
                  T
                </tspan>
              </text>
            </g>
            <g
              data-name="S"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["s"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="233.2"
                y="165.7"
                width="10"
                height="24"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="238.2" cy="182.4" r="8" />
              <text className={classes.st7} transform="translate(235.5 185.4)">
                <tspan x="0" y="0">
                  S
                </tspan>
              </text>
            </g>
            <g
              data-name="R"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["r"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="257.4"
                y="165.7"
                width="10"
                height="29"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="262.4" cy="182.4" r="8" />
              <text className={classes.st6} transform="translate(259.5 185.4)">
                <tspan x="0" y="0">
                  R
                </tspan>
              </text>
            </g>
            <g
              data-name="Q"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["q"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="281.9"
                y="172.8"
                width="10"
                height="34"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="286.9" cy="189.5" r="8" />
              <text className={classes.st7} transform="translate(283.7 192.5)">
                <tspan x="0" y="0">
                  Q
                </tspan>
              </text>
            </g>
            <g
              data-name="P"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["p"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="304.9"
                y="172.8"
                width="10"
                height="39"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="309.9" cy="189.5" r="8" />
              <text className={classes.st7} transform="translate(307.2 192.5)">
                <tspan x="0" y="0">
                  P
                </tspan>
              </text>
            </g>
            <g
              data-name="O"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["o"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="329.3"
                y="172.8"
                width="10"
                height="44"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="334.3" cy="189.5" r="8" />
              <text className={classes.st7} transform="translate(331.1 192.5)">
                <tspan x="0" y="0">
                  O
                </tspan>
              </text>
            </g>
            <g
              data-name="N"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["n"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="354.1"
                y="172.8"
                width="10"
                height="50"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="359.1" cy="189.5" r="8" />
              <text className={classes.st6} transform="translate(356.1 192.5)">
                <tspan x="0" y="0">
                  N
                </tspan>
              </text>
            </g>
            <g
              data-name="M"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["m"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="377.2"
                y="171.9"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="382.2" cy="208.1" r="8" />
              <text className={classes.st7} transform="translate(378.8 211.1)">
                <tspan x="0" y="0">
                  M
                </tspan>
              </text>
            </g>
            <g
              data-name="L"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["l"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="402"
                y="172.3"
                width="10"
                height="60"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="407" cy="208.6" r="8" />
              <text className={classes.st6} transform="translate(404.5 211.6)">
                <tspan x="0" y="0">
                  L
                </tspan>
              </text>
            </g>
            <g
              data-name="K"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["k"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="425.9"
                y="173.2"
                width="10"
                height="66"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="430.9" cy="209.5" r="8" />
              <text className={classes.st6} transform="translate(428 212.5)">
                <tspan x="0" y="0">
                  K
                </tspan>
              </text>
            </g>
            <g
              data-name="J"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["j"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="456.5"
                y="173.7"
                width="10"
                height="71"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="461.5" cy="209.9" r="8" />
              <text className={classes.st6} transform="translate(459.2 212.9)">
                <tspan x="0" y="0">
                  J
                </tspan>
              </text>
            </g>
            <g
              data-name="I"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["i"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="479.5"
                y="174.1"
                width="10"
                height="76"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="484.5" cy="210.4" r="8" />
              <text className={classes.st7} transform="translate(483.4 213.4)">
                <tspan x="0" y="0">
                  I
                </tspan>
              </text>
            </g>
            <g
              data-name="H"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["h"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="502.1"
                y="173.2"
                width="10"
                height="82"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="507.1" cy="209.5" r="8" />
              <text className={classes.st6} transform="translate(504.1 212.5)">
                <tspan x="0" y="0">
                  H
                </tspan>
              </text>
            </g>
            <g
              data-name="G"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["g"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="527.3"
                y="173.7"
                width="10"
                height="87"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="532.3" cy="209.9" r="8" />
              <text className={classes.st7} transform="translate(529.1 212.9)">
                <tspan x="0" y="0">
                  G
                </tspan>
              </text>
            </g>
            <g
              data-name="F"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["f"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="551.7"
                y="172.8"
                width="10"
                height="92"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="556.7" cy="209" r="8" />
              <text className={classes.st6} transform="translate(554.2 212)">
                <tspan x="0" y="0">
                  F
                </tspan>
              </text>
            </g>
            <g
              data-name="E"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["e"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="577.4"
                y="172.8"
                width="10"
                height="56"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="582.4" cy="199.7" r="8" />
              <text className={classes.st7} transform="translate(579.7 202.7)">
                <tspan x="0" y="0">
                  E
                </tspan>
              </text>
            </g>
            <g
              data-name="DD"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["dd"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="597.4"
                y="172.8"
                width="10"
                height="56"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="602.4" cy="199.7" r="8" />
              <text className={classes.st6} transform="translate(596.5 202.7)">
                <tspan x="0" y="0">
                  DD
                </tspan>
              </text>
            </g>
            <g
              data-name="CC"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["cc"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="616.4"
                y="172.8"
                width="10"
                height="56"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="621.4" cy="199.7" r="8" />
              <text className={classes.st6} transform="translate(615.5 202.7)">
                <tspan x="0" y="0">
                  CC
                </tspan>
              </text>
            </g>
            <g
              data-name="BB"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["bb"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="636.4"
                y="172.8"
                width="10"
                height="56"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="641.4" cy="199.7" r="8" />
              <text className={classes.st6} transform="translate(635.5 202.7)">
                <tspan x="0" y="0">
                  BB
                </tspan>
              </text>
            </g>
            <g
              data-name="AA"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["aa"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="655.4"
                y="172.8"
                width="10"
                height="56"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="660.4" cy="199.7" r="8" />
              <text className={classes.st6} transform="translate(654.5 202.7)">
                <tspan x="0" y="0">
                  AA
                </tspan>
              </text>
            </g>
            <g
              data-name="E"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["e"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="577.4"
                y="236.8"
                width="10"
                height="42"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="582.4" cy="258.8" r="8" />
              <text className={classes.st7} transform="translate(579.7 261.8)">
                <tspan x="0" y="0">
                  E
                </tspan>
              </text>
            </g>
            <g
              data-name="D"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["d"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="597.4"
                y="236.8"
                width="10"
                height="49"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="602.4" cy="258.8" r="8" />
              <text className={classes.st6} transform="translate(599.5 261.8)">
                <tspan x="0" y="0">
                  D
                </tspan>
              </text>
            </g>
            <g
              data-name="C"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["c"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="616.4"
                y="236.8"
                width="10"
                height="55"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="621.4" cy="258.8" r="8" />
              <text className={classes.st6} transform="translate(618.5 261.8)">
                <tspan x="0" y="0">
                  C
                </tspan>
              </text>
            </g>
            <g
              data-name="B"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["b"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="636.4"
                y="236.8"
                width="10"
                height="61"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="641.4" cy="258.8" r="8" />
              <text className={classes.st6} transform="translate(638.5 261.8)">
                <tspan x="0" y="0">
                  B
                </tspan>
              </text>
            </g>
            <g
              data-name="A"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["a"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="655.4"
                y="236.8"
                width="10"
                height="67"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="660.4" cy="258.8" r="8" />
              <text className={classes.st6} transform="translate(657.5 261.8)">
                <tspan x="0" y="0">
                  A
                </tspan>
              </text>
            </g>
            <g
              data-name="W"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["w"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="529.7"
                y="413.7"
                width="10"
                height="32"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="534.7" cy="439.7" r="8" />
              <text className={classes.st7} transform="translate(530.8 442.7)">
                <tspan x="0" y="0">
                  W
                </tspan>
              </text>
            </g>
            <g
              data-name="X"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["x"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="507.9"
                y="429.2"
                width="10"
                height="30"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="512.9" cy="453.2" r="8" />
              <text className={classes.st7} transform="translate(510.2 456.2)">
                <tspan x="0" y="0">
                  X
                </tspan>
              </text>
            </g>
            <g
              data-name="Y"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["y"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="484"
                y="446.6"
                width="10"
                height="26"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="489" cy="466.6" r="8" />
              <text className={classes.st7} transform="translate(486.3 469.6)">
                <tspan x="0" y="0">
                  Y
                </tspan>
              </text>
            </g>
            <g
              data-name="Z"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["z"]
              })}
            >
              <rect
                className={classes.barnPath}
                x="460.4"
                y="464.8"
                width="10"
                height="26"
                rx="1.5"
                ry="1.5"
              />
              <circle className={classes.circle} cx="465.4" cy="484.8" r="8" />
              <text className={classes.st6} transform="translate(462.9 487.8)">
                <tspan x="0" y="0">
                  Z
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default React.memo(DelMarMap, mapPropsAreEqual);
